import type { ReactNode, JSX } from 'react'

import styles from './FeedRow.module.css'

type FeedRowProps = {
  children: ReactNode
}

/**
 * Aligns its children with the comments feed grid layout: a content column
 * (matching --comment-card-max-width, ~685px) plus a reserved action column
 * for dismiss/check icon buttons that sit next to each comment.
 *
 * Use for anything that should visually line up with the comments feed —
 * banners, notices, empty states, the engagement panel, etc. Callers are
 * responsible for not rendering FeedRow when there's nothing to show.
 */
export const FeedRow = ({ children }: FeedRowProps): JSX.Element => {
  return <div className={styles.row}>{children}</div>
}
